import $ from "jquery";
import * as d3 from "d3";
import {
  checkTooBigDevices,
  CleanupAll,
  closeWizListDelay,
  isPlannerBusy,
  setMode,
} from "src/components/Planner/planner/planner";
import {PlannerGlobals} from "src/components/Planner/planner/planner-globals";
import {SERIAL_SPACING} from "src/components/Planner/planner/serial-layout";
import {instantCalcOuter} from "src/components/Planner/planner/outerwall";
import {
  ALGO_TYPES,
  CONV_LIGHT_CATEG_ID,
  CONV_LIGHT_SWITCH_IDS,
  CONV_SHADING_CATEG_ID,
  CONV_SHADING_SWITCH_IDS,
  LOX_LIGHT_CATEG_ID,
  LOX_SHADING_CATEG_ID,
  ROOM_TYPES
} from "src/components/Planner/planner/wizard-constants";
import {
  doesDeviceFitRoom,
  P_numtoxy,
  P_numtoxyPlusHalf,
  P_xytonum,
  P_xytonumPlusHalf,
  PointPlusHalf,
  rotatePointAroundAnotherXY,
  snapDeviceToWall,
  uMath,
  vectorRotationDegree,
  XYtoNumPoly,
} from "src/components/Planner/planner/uMath";
import {
  GET_SER_BORDER_WIDTH,
  GET_SER_MARG,
  getDeviceById,
  getFrameHeight,
  getFrameWidth,
  getGroupsOfDevice,
  getInnerRooms,
  getOuterRooms,
  getRoomById,
  getSerialById,
  getSerialCenterXY,
  getSerialOfDeviceId,
  isRoomOutside,
  rebuildWallsCache,
  uDev,
  UDevGlobals,
  whichRoomArePointsIn
} from "src/components/Planner/planner/uDev";
import {
  getProductById,
  removeDevices,
  removeTheseDevs,
  uDevDOM
} from "src/components/Planner/planner/uDev-dom";
import {
  placeDevice,
  redrawDevices
} from "src/components/Planner/planner/deviceDrawing";
import {
  mouseupGroup,
  redrawGroups
} from "src/components/Planner/planner/grouping";
import {wallModHelper} from "src/components/Planner/planner/wallModHelper";
import {
  wallModHelperDOM
} from "src/components/Planner/planner/wallModHelper-dom";
import {
  connectSerials
} from "src/components/Planner/planner/serialConnections-dom";
import {
  DeleteMultipleDevicesAction
} from "src/components/Planner/planner/history/device-actions";
import {
  WizardPlaceAction
} from "src/components/Planner/planner/history/wizard-actions";
import {MultiPlannerAction} from "src/components/Planner/planner/history";
import {WIFI_BAND, WIFI_BANDS} from "src/components/Planner/planner/wificalc";
import {
  IS_ON_SERVER,
  printTimeTaken,
  toastRemoveAll,
  whenAll
} from "src/components/Planner/controller";
import {
  hideLoadingOverlay,
  setLoadingProgress,
  setLoadingText,
  showLoadingOverlay,
  snackError,
  snackInfo,
  snackSuccess
} from "src/utils/legacyUiAdapter";
import {ts} from "src/utils/translate";
import {deviceProvider} from "src/components/Planner/planner/DeviceProvider";
import {projectHasSiren} from "src/utils/projectSirenAdapter";
import {genericOKCancelSwal} from "src/utils/swal";
import {
  refreshFloorView
} from "src/components/Planner/planner/plannerCacheInvalidation";
import {calcImageURL} from "src/utils/url";

/**
 * @typedef {Object} CenterGroup
 * @property {[number, number]} origiCenter
 * @property {[number, number]} origiDevPlacement
 * @property {WizardPlacement[]} centers
 */

/**
 * @typedef {Object} WizardPlacement
 * @property {[number,number]} centroid CENTER of device
 * @property {[number,number]} devPlacement TOP LEFT of device
 * @property {number} devAngle ROTATION of device
 * @property {number} devId PRODUCT NAME ID of device
 * @property {number} roomId
 * @property {"windows"|"doors"} type
 * @property {"switch"|"other"|"wifi"} role
 * @property {boolean?} serializable
 * @property {{connId, id, roomId}?} wallMod
 */
export const WizardGlobals = {
  WIFI_PRODUCT_ID: 277,
}

const WIZARD_PLACED_EVENT = 'wizard-placed';

export const GROUP_BY = function (xs, key) {
  return xs.reduce(function (rv, x) {
    (rv[x[key]] = rv[x[key]] || []).push(x);
    return rv;
  }, {});
};

/**
 * Contains logic for automatically placing lights, actuators, reed switches, and movement sensors
 */
export const PLANNER_WIZARD = {
  /**
   * @type {CenterGroup[]}
   */
  centerGroups: [],
  conventionalPlacements: [],
  deleteRequests: [],
  incompleteRooms: [],
  workers: [],
  workerPromises: [],
  workerPromises2ndRound: [],
  autoAccept: false,
  ALGO_TYPES,
  LOX_LIGHT_CATEG_ID,
  LOX_SHADING_CATEG_ID,
  CONV_LIGHT_CATEG_ID,
  CONV_SHADING_CATEG_ID,
  CONV_LIGHT_SWITCH_IDS,
  CONV_SHADING_SWITCH_IDS,
  wizardMode() {
    CleanupAll();
    $('.tooltip').hide();
    closeWizListDelay(0);
    PlannerGlobals.mode = 'wizard';
  },

  cleanupWizard() {
    d3.selectAll('.suggestion-radiuses').remove();
    $('.planner-icon-btn').not('#planner-sizers > .planner-icon-btn').not('.planner-modify-item').not('#planner-history-reset-btn').removeClass('hidden');
    $('.wizard-hidden-btn').addClass('hidden');
    $('.planner-modify-item').addClass('hidden');
    $('.planner-buttons-cont.planner-modify-item').removeClass('hidden');
    $('#wizard-btn-' + PLANNER_WIZARD.lastStartedMode).find('.rotate-cog').addClass('hidden');
    $('.planner-icon-separator').removeClass('hidden');
    d3.selectAll('.suggestionItem').remove();
    PLANNER_WIZARD.resetWorkers();
  },

  startLoading() {
    // if (newTour.isOngoing() && newTour.currStepId === "wizard") {
    //     $('.page-header').show().css('pointer-events', 'none');
    //     $('.page-container').css('margin-top', '');
    // }

    $('#wizard-btn-' + PLANNER_WIZARD.lastStartedMode).find('.rotate-cog').removeClass('hidden');
    $('.planner-icon-btn').not('#planner-sizers > .planner-icon-btn').not('#wizard-btn-' + PLANNER_WIZARD.lastStartedMode).addClass('hidden');
    $('#wizard-btn-' + PLANNER_WIZARD.lastStartedMode).removeClass('hidden');
    $('.planner-icon-separator').addClass('hidden');
    toastRemoveAll();
    showLoadingOverlay();
    snackInfo(ts('p_wiz_calcprog', "Calculating..."));
  },

  filterOutDeleteRequestsTemporarily() {
    var origiDevs = $.extend(true, [], PlannerGlobals.devices);
    var origiGroups = $.extend(true, [], PlannerGlobals.groups);
    var origiSerials = $.extend(true, [], PlannerGlobals.serials);

    var delDevs = this.getDevsToRemove();
    delDevs.forEach(function (dev) {
      var dev2 = PlannerGlobals.devices.find(function (dev2) { return dev2.deviceId === dev.deviceId; });
      if (dev2) {
        dev2.deleted = true;
      }
    });
    delDevs.forEach(function (dev) {
      var deviceId = dev.deviceId;
      var devGroups = getGroupsOfDevice(deviceId);
      devGroups.forEach(function (devGroup) {
        var idx = devGroup.deviceIds.findIndex(function (deviceIdCurr) {
          return deviceIdCurr == deviceId;
        });
        if (idx != -1) {
          devGroup.deviceIds.splice(idx, 1);
          if (devGroup.deviceIds.length < 2) {
            var idx = PlannerGlobals.groups.findIndex(function (group) {
              return group.id == devGroup.id;
            });
            if (idx != -1) {
              PlannerGlobals.groups.splice(idx, 1);
            }
          }
        }
      });
      var devSerial = getSerialOfDeviceId(deviceId);
      if (devSerial) {
        var idx = devSerial.deviceIds.findIndex(function (deviceIdCurr) {
          return deviceIdCurr == deviceId;
        });
        if (idx != -1) {
          devSerial.deviceIds.splice(idx, 1);
          if (devSerial.deviceIds.length < 1) {
            var idx = PlannerGlobals.serials.findIndex(function (serial) {
              return serial.id == devSerial.id;
            });
            if (idx != -1) {
              PlannerGlobals.serials.splice(idx, 1);
            }
          }
        }
      }
    });

    PlannerGlobals.devices = PlannerGlobals.devices.filter(function (dev) { return !dev.deleted; })
    UDevGlobals.cachedDevices = {};
    UDevGlobals.devIdSerialCache = {};

    return { origiDevs, origiGroups, origiSerials };
  },

  restoreBeforeFilterState(saveState) {
    PlannerGlobals.groups = saveState.origiGroups;
    PlannerGlobals.serials = saveState.origiSerials;
    PlannerGlobals.devices = saveState.origiDevs;
    UDevGlobals.cachedDevices = {};
    UDevGlobals.devIdSerialCache = {};
    UDevGlobals.serialIdMap = {};
  },

  stopLoading() {
    hideLoadingOverlay();
    $('#wizard-btn-' + PLANNER_WIZARD.lastStartedMode).find('.rotate-cog').addClass('hidden');
    $('#confirm-modify-btn, #undo-modify-btn').removeClass('hidden');
    toastRemoveAll();
    if (this.centerGroups.length == 0 && this.conventionalPlacements.length == 0) {
      this.declineChanges();
      snackInfo(ts('p_wiz_nochange', "The uPlan Wizard couldn't find new items to place."));
      document.dispatchEvent(new Event(WIZARD_PLACED_EVENT));
    }
    else {
      if (!this.autoAccept) {
        snackSuccess(ts('p_wiz_calcdone', "Calculation complete! You can accept or decline the changes."));
      }
      /* if (this.lastStartedMode === "conventional") {
          snackInfo(ts2("wiz_comfort_info", "Comfort level {0} was used. It can be changed in the project's settings.", { 0: comfortLevel }));
      } */
      var thisVar = this;
      if (this.deleteRequests.length && !this.autoAccept) {
        var saveState = this.filterOutDeleteRequestsTemporarily()

        redrawDevices();
        redrawGroups();

        this.restoreBeforeFilterState(saveState);

        genericOKCancelSwal("The wizard will replace some existing devices with its own recommendations.", "OK", function () {
          thisVar.acceptChanges();
        }, function () {
          thisVar.declineChanges();
        });
      }
      else {
        if (IS_ON_SERVER || this.autoAccept) {
          this.acceptChanges(); // REMOVE TO DISABLE AUTO ACCEPT
        }
        else {
          snackInfo("CHANGES ARE AUTO ACCEPTED ON SERVER ONLY (app.uplan.io or test.uplan.io)");
        }
      }
    }
    if (this.incompleteRooms.length != 0) {
      snackError((ts('p_wiz_roomsmall', "We couldn't fit every item in the following rooms since they're too small:") + " <b>" +
          this.incompleteRooms.map(function (room) { return room.roomname; }).sort().join(', ')) + "</b>");
    }
  },

  getProductNode(productNameId) {
    return getProductById(productNameId);
  },

  /**
   *
   * @param {Point[]} takenPlaces
   * @param {Point} newPt
   * @param {number} threshold
   */
  isBad(takenPlaces, newPt, threshold = PlannerGlobals.DEVICE_SIZE) {
    return takenPlaces.some(function (pt) {
      return uMath.pointDistance(newPt, pt) < threshold;
    });
  },

  /**
   *
   * @param {WizDevPlacement} currDev
   * @param {Point[]} takenPlaces
   */
  nudgeDev(currDev, takenPlaces, threshold = PlannerGlobals.DEVICE_SIZE) {
    var validPlacements = [];
    var toNudge = P_numtoxy(currDev.devPlacement);
    for (var i = 1; i <= 5; i++) {
      if (validPlacements.length) {
        break;
      }
      for (var angle = 0; angle < 360; angle += 30) {
        var newPt = uMath.pointAtAngleDistance(toNudge, angle, PlannerGlobals.DEVICE_SIZE * 1.05 * i);
        if (!this.isBad(takenPlaces, PointPlusHalf(newPt), threshold)) {
          var allPts = uDev.deviceAllPts(newPt, currDev.devAngle);
          var newRoom = whichRoomArePointsIn(allPts);
          if (newRoom && newRoom.id == currDev.roomId) {
            validPlacements.push({
              roomId: newRoom.id,
              devPlacement: P_xytonum(newPt),
              centroid: [newPt.x + PlannerGlobals.DEVICE_SIZE / 2, newPt.y + PlannerGlobals.DEVICE_SIZE / 2],
              devAngle: currDev.devAngle,
              distFromOrigi: PlannerGlobals.DEVICE_SIZE * 1.05 * i
            });
          }
          else {
            var snapped = snapDeviceToWall(newPt, PlannerGlobals.DEVICE_SIZE * 2, undefined, undefined, undefined, undefined, undefined);
            if (snapped && snapped.room.id == currDev.roomId) {
              if (!this.isBad(takenPlaces, PointPlusHalf(snapped.point), threshold)) {
                validPlacements.push({
                  roomId: snapped.room.id,
                  devPlacement: P_xytonum(snapped.point),
                  centroid: [snapped.point.x + PlannerGlobals.DEVICE_SIZE / 2, snapped.point.y + PlannerGlobals.DEVICE_SIZE / 2],
                  devAngle: snapped.rotation,
                  distFromOrigi: PlannerGlobals.DEVICE_SIZE * 1.05 * i
                });
              }
            }
          }

        }
      }
    }

    if (validPlacements.length) {
      for (var prop in validPlacements[0]) {
        currDev[prop] = validPlacements[0][prop];
      }
    }
  },

  post_arrangeWifi() {
    rebuildWallsCache();
    var thisVar = this;
    /**
     * @type {WizDevPlacement[]}
     */
    var wifis = [];
    // get newly placed wifi items
    thisVar.centerGroups.forEach(function (centerGroup) {
      centerGroup.centers.forEach(function (center) {
        if (center.type == 'wifi') {
          wifis.push(center);
        }
      });
    });
    wifis.forEach(function (wifiDev) {
      var currCenter = P_numtoxy(wifiDev.devPlacement);
      // get all items that are in the same room ALREADY or WILL BE PLACED there
      var collisionCheckDevs = PlannerGlobals.devices.filter(function (device) { return device.roomId == wifiDev.roomId; })
      .map(function (dev) { return uDev.getCenterOfDevice_NoDOM(dev.deviceId); });
      thisVar.centerGroups.forEach(function (centerGroup) {
        centerGroup.centers.forEach(function (center) {
          if (center != wifiDev && center.roomId == wifiDev.roomId) {
            collisionCheckDevs.push({ x: center.devPlacement[0], y: center.devPlacement[1] });
          }
        });
      });
      // check items for collision
      if (thisVar.isBad(collisionCheckDevs, currCenter, PlannerGlobals.DEVICE_SIZE * 1.5)) {
        thisVar.nudgeDev(wifiDev, collisionCheckDevs, PlannerGlobals.DEVICE_SIZE * 1.5);
      }
    });
  },
  /**
   *
   * @param {WizDevPlacement} center
   */
  getAllDevsAndWillBePlacedsExcept(center) {
    var thisVar = this;
    var devs = PlannerGlobals.devices
    .filter(function (dev) {
      return dev.roomId == center.roomId;
    })
    .map(function (dev) {
      return uDev.getCenterOfDevice_NoDOM(dev.deviceId);
    });
    var centers = thisVar.flattenCenters(thisVar.centerGroups)
    .filter(function (c) {
      return c != center;
    })
    .map(function (c) {
      return P_numtoxy(c.centroid);
    });
    return devs.concat(centers);
  },
  appendCircle(x, y) {
    PlannerGlobals.container.append('circle')
      .attr('class', 'testc')
      .attr('cx', x)
      .attr('cy', y)
      .attr('r', 1)
      .attr('fill', 'black')
  },
  post_hitTest() {
    var thisVar = this;
    PlannerGlobals.rooms.forEach(function (room) {
      var wasProblematic = false;
      var roomDevs = PlannerGlobals.devices.filter(function (dev) { return dev.roomId == room.id });
      var roomPoly = XYtoNumPoly(room.poly);
      thisVar.centerGroups.forEach(function (centerGroup) {
        centerGroup.centers.forEach(function (center) {
          if (center.roomId != room.id || center.type == "wifi") { return; }
          if (uDev.isPlaceTaken(P_numtoxyPlusHalf(center.devPlacement), roomDevs, PlannerGlobals.DEVICE_SIZE * 0.8)) {
            thisVar.nudgeDev(center, thisVar.getAllDevsAndWillBePlacedsExcept(center), PlannerGlobals.DEVICE_SIZE * 0.8);
            var res = uDev.isPlaceTaken(P_numtoxyPlusHalf(center.devPlacement), roomDevs, PlannerGlobals.DEVICE_SIZE * 0.8)
            if (res) {
              center.noDraw = true;
              wasProblematic = true;
            }
          }
          else {
            var allPts = uDev.deviceAllPts(P_numtoxy(center.devPlacement), center.devAngle);
            if (!allPts.every(function (pt) {
              return d3.polygonContains(roomPoly, P_xytonum(pt));
            })) {
              center.noDraw = true;
              wasProblematic = true;
            }
          }
        });
      });
      if (wasProblematic) {
        var isNotIn = thisVar.incompleteRooms.findIndex(function (incompleteRoom) { return incompleteRoom.id == room.id; }) == -1;
        if (isNotIn) {
          thisVar.incompleteRooms.push(room);
        }
      }
    });
  },

  post_filterBads() {
    this.centerGroups.forEach(function (centerGroup) {
      centerGroup.centers = centerGroup.centers.filter(function (center) {
        return !center.noDraw;
      });
    });
    this.centerGroups = this.centerGroups.filter(function (centerGroup) {
      return !!centerGroup.centers.length;
    });
  },
  post_showPreviewGroups() {
    var thisVar = this;
    var newlyPlaced = this.flattenCenters(this.centerGroups).filter(function (dev) {
      return thisVar.speakerPNIDs.indexOf(+dev.devId) != -1;
    });
  },

  post_oneMeteo() {
    var devs = this.centerGroups
    .map(function (cg) {
      return cg.centers;
    })
    .reduce(function (p, c) {
      return p.concat(c);
    }, [])
    .filter(function (dev) {
      return dev.devId == 139;
    });

    if (PlannerGlobals.devices.filter(function (dev) {
      return dev.product_name_id == 139;
    }).length > 0) {
      devs.forEach(function (dev) {
        dev.noDraw = true;
      });
      return;
    }

    var meteos = devs
    .filter(function (dev) {
      return isRoomOutside(getRoomById(dev.roomId), PlannerGlobals.outerBorder);
    })
    .sort(function (a, b) {
      var lenA = uMath.pointClosestPtToPolygon(P_numtoxy(a.devPlacement), PlannerGlobals.outerBorder);
      var lenB = uMath.pointClosestPtToPolygon(P_numtoxy(b.devPlacement), PlannerGlobals.outerBorder);
      return lenA < lenB ? -1 : 1;
    });

    for (var i = 1; i < meteos.length; i++) {
      meteos[i].noDraw = true;
    }

    devs
    .filter(function (dev) {
      return !isRoomOutside(getRoomById(dev.roomId), PlannerGlobals.outerBorder);
    })
    .forEach(function (dev) {
      dev.noDraw = true;
    });
  },
  post_oneSiren() {
    try {
      var hasSiren = projectHasSiren(PlannerGlobals.plannerProjectId);

      var sirensToBePlaced = this.centerGroups
      .map(function (cg) {
        return cg.centers;
      })
      .reduce(function (p, c) {
        return p.concat(c);
      }, [])
      .filter(function (dev) {
        return dev.devId == 229;
      });

      sirensToBePlaced.forEach(function (dev) {
        dev.noDraw = true;
      });

      if (!hasSiren && sirensToBePlaced.length) {
        sirensToBePlaced.sort(function (a, b) {
          return a.outerDoor.id < b.outerDoor.id ? -1 : 1;
        });
        sirensToBePlaced[0].noDraw = false;
      }
    }
    catch (err) {
      console.log(err);
    }
  },
  /**
   *
   * @param {WizardPlacement[]} speakers
   */
  drawGroupFor(speakers) {
    var centroids = speakers.map(function (sp) {
      return P_numtoxyPlusHalf(sp.devPlacement);
    });

    var lineFunction = d3.line()
      .curve(d3.curveBasis);

    for (var i = 1; i < centroids.length; i++) {
      var prevPt = centroids[i - 1];
      var currPt = centroids[i];
      var centerPt = uMath.pointsCenter(prevPt, currPt);

      var angle = vectorRotationDegree(prevPt, currPt) % 180 - 90;
      centerPt = uMath.pointAtAngleDistance(centerPt, angle, 10);

      var pts = [prevPt, centerPt, currPt].map(P_xytonum);

      PlannerGlobals.container.append('path')
        .attr('class', 'suggestionItem')
        .attr('d', lineFunction(pts))
        .attr('stroke', 'black')
        .attr('stroke-width', 0.5)
        .attr('stroke-dasharray', '3 1')
        .attr('fill', 'none');
    }
  },

  post_arrangeOthers() {
    var others = [];
    this.centerGroups.forEach(function (centerGroup) {
      centerGroup.centers.forEach(function (center) {
        if ('wallMod' in center) {
          if (center.role == 'other') {
            others.push(center);
          }
          center.room = getRoomById(center.wallMod.roomId);
        }
      });
    });
    var ETC_TYPE = 10;
    var BEDROOM_TYPE = 4;

    others.forEach(function (center) {
      var similars = uDev.elemsNearWallMod(center.wallMod.connId, center.devId, PlannerGlobals.DEVICE_SIZE * 5);
      if (similars.length > 0) {
        center.noDraw = true;
      }
    });
  },

  post_arrangeSwitches2() {
    var devs = this.flattenCenters(this.centerGroups)
    .filter(function (dev) { return dev.role == "switch" });

    if (devs.length == 0) {
      return;
    }

    devs.forEach(function (dev) { dev.wallModConnId = dev.wallMod.connId; dev.wallModId = dev.wallMod.id; });

    var switchPNID = devs[0].devId;

    var singleSwitchRoomTypes = [5, 8, 9, 10, 11, 12];

    // only keep the first switch of every door-pair
    var devsByConnId = GROUP_BY(devs, "wallModConnId");
    for (var i in devsByConnId) {
      if (devsByConnId[i].length == 2) {
        var etcIdx = devsByConnId[i].findIndex(function (dev) {
          var room = getRoomById(dev.roomId);
          return room && room && singleSwitchRoomTypes.indexOf(room.room_type_id) != -1
        });
        if (etcIdx != -1) {
          if (etcIdx == 0) {
            devsByConnId[i][1].noDraw = true;
          }
          else {
            devsByConnId[i][0].noDraw = true;
          }
        }
        else {
          devsByConnId[i][1].noDraw = true;
        }
      }
    }

    // but regardless always keep one switch in every room (for sensing temperature)
    var devsByRoomId = GROUP_BY(devs, "roomId");
    for (var i in devsByRoomId) {
      if (devsByRoomId[i].every(function (dev) {
        return dev.noDraw;
      })) {
        devsByRoomId[i][0].noDraw = false;
      }
    }

    // where there already is a placed switch, remove the wizard placed switch
    /* var wallModsFlat = wallModHelper.getWallMods(); */

    var reservedWallMods = PlannerGlobals.devices
    .filter(function (dev) {
      return dev.product_name_id == switchPNID;
    })
    .map(function (swch) {
      var mods = wallModHelper.getWallModsOfRoomByType(swch.roomId, "door");
      return uDev.closestWallModToPoint(swch, mods);
    })
    .filter(function (wallMod) {
      return !!wallMod;
    });

    var reservedWallModIds = [];

    for (var i in GROUP_BY(reservedWallMods, "id")) {
      reservedWallModIds.push(+i);
    }

    var devsByWallModId = GROUP_BY(devs, "wallModId");
    for (var wallModId in devsByWallModId) {
      if (reservedWallModIds.indexOf(+wallModId) != -1) {
        for (var j = 0; j < devsByWallModId[wallModId].length; j++) {
          devsByWallModId[wallModId][j].noDraw = true;
        }
      }
    }

    var devsByConnId2 = GROUP_BY(devs.filter(function (d) { return !d.noDraw; }), "wallModConnId");
    // if the other side of wallmodconn already has a dev AND this room already has one switch for temp sense, then dont draw this
    for (var i in devsByConnId2) {
      if (devsByConnId2[i].length == 1 && !devsByConnId2[i][0].noDraw) {
        var dev = devsByConnId2[i][0];
        var elems = uDev.elemsNearWallMod(dev.wallModConnId, switchPNID);
        var room = getRoomById(dev.roomId);
        if (elems.length && uDev.numberOfProductInRoom(room, switchPNID) > 0) {
          dev.noDraw = true;
        }
        /* console.log(dev, elems); */
      }
    }

    devs
    .filter(function (dev) {
      return !dev.noDraw;
    })
    .forEach(function (dev) {
      var otherWallMod = wallModHelper.getWallModConnOtherRoom(dev.wallMod.connId, dev.wallMod.roomId);
      if (otherWallMod) {
        var isOtherReserved = reservedWallModIds.indexOf(+otherWallMod.id) != -1;
        var otherRoom = getRoomById(otherWallMod.roomId);
        var isOtherETC = otherRoom && singleSwitchRoomTypes.indexOf(otherRoom.room_type_id) != -1;
        var thisRoom = getRoomById(dev.roomId);
        var isThisNotETC = thisRoom && singleSwitchRoomTypes.indexOf(thisRoom.room_type_id) == -1;
        if (isOtherETC && isOtherReserved && isThisNotETC) {
          dev.noDraw = true;
        }
      }
    });
  },

  post_removeNonExistents() {
    var thisVar = this;
    var centers = this.flattenCenters(this.centerGroups);
    centers.forEach(function (center) {
      center.dev = thisVar.getProductNode(center.devId);
      if (!center.dev) {
        center.noDraw = true;
        console.warn("Wizard tried to place device with PNID " + center.devId + " but it's not in the device tree. Skipping...");
      }
    });
  },

  post_arrangeOutdoorItemsInRooms() {
    var outdoorRooms = PlannerGlobals.rooms.filter(function (room) { return isRoomOutside(room, PlannerGlobals.outerBorder); });
    /**
     * @type {WizDevPlacement[]}
     */
    var outdoorItems = [];
    this.centerGroups.forEach(function (grp) {
      grp.centers.forEach(function (center) {
        if (center.roomId === uDev.OUTDOORS_ROOM_ID) {
          outdoorItems.push(center);
        }
      });
    });

    var thisVar = this;
    outdoorItems.forEach(function (center) {
      rebuildWallsCache(null, true, true);

      var devPts = uDev.deviceAllPts(P_numtoxy(center.devPlacement), center.devAngle);
      var containingRoom = outdoorRooms.find(function (room) {
        var roomPoly = XYtoNumPoly(room.poly);
        return devPts.some(function (devPt) { return d3.polygonContains(roomPoly, P_xytonum(devPt)); });
      })
      if (containingRoom) {
        var snappedPlace = snapDeviceToWall(P_numtoxy(center.centroid), PlannerGlobals.DEVICE_SIZE * 5, 1, true, undefined, undefined, undefined);
        if (snappedPlace) {
          center.roomId = snappedPlace.room.id;
          center.devPlacement = P_xytonum(snappedPlace.point);
          center.centroid = P_xytonumPlusHalf(snappedPlace.point);
          center.devAngle = snappedPlace.rotation;
        }
        else {
          var collisionCheckDevs = PlannerGlobals.devices.map(function (dev) { return uDev.getCenterOfDevice_NoDOM(dev.deviceId); });
          thisVar.centerGroups.forEach(function (centerGroup) {
            centerGroup.centers.forEach(function (x) {
              if (x != center) {
                collisionCheckDevs.push({ x: x.devPlacement[0], y: x.devPlacement[1] });
              }
            });
          });
          PLANNER_WIZARD.nudgeDev(center, collisionCheckDevs);
        }
      }
      else {
        var outdoorsFitDev = doesDeviceFitRoom(uDev.OUTDOORS_ROOM_ID, P_numtoxy(center.devPlacement), center.devAngle, 1);
        var anyOuterIntersectsDev = uDev.anyOutdoorRoomIntersectsDev(P_numtoxy(center.devPlacement), center.devAngle);
        if (!outdoorsFitDev || anyOuterIntersectsDev) {
          var snappedPlace = snapDeviceToWall(P_numtoxy(center.devPlacement), PlannerGlobals.DEVICE_SIZE * 10, 1, false, false, 10, false);
          if (!snappedPlace) {
            rebuildWallsCache(null, false, false);
            snappedPlace = snapDeviceToWall(P_numtoxy(center.devPlacement), PlannerGlobals.DEVICE_SIZE * 10, 1, false, false, 10, false);
          }
          if (snappedPlace) {
            center.roomId = snappedPlace.room.id;
            center.devPlacement = P_xytonum(snappedPlace.point);
            center.centroid = P_xytonumPlusHalf(snappedPlace.point);
            center.devAngle = snappedPlace.rotation;
          }
        }
      }
    });
  },

  postProcessResults() {
    var saveState = this.filterOutDeleteRequestsTemporarily();

    this.post_removeNonExistents();
    this.post_arrangeOutdoorItemsInRooms();
    this.post_filterBads();
    this.post_arrangeOthers();
    this.post_arrangeSwitches2();
    this.post_oneMeteo();
    this.post_oneSiren();
    this.post_filterBads();
    this.post_arrangeWifi();
    this.post_hitTest();
    this.post_filterBads();
    this.post_showPreviewGroups();

    this.restoreBeforeFilterState(saveState);
  },

  /**
   *
   * @param {*} centerGroups
   * @returns {WizDevPlacement[]}
   */
  flattenCenters(centerGroups) {
    return centerGroups.map(function (cg) {
      return cg.centers;
    }).reduce(function (p, c) { return p.concat(c); }, []);
  },

  /**
   *
   * @param {*} conventionalPlacements
   * @returns {{devs: any[], serialIds: number[]}}
   */
  flattenConvPlacements(conventionalPlacements) {
    var devs = [];
    var serialIds = [];

    conventionalPlacements.forEach(function (conventionalPlacement) {
      if (conventionalPlacement.type === "serial") {
        serialIds.push(conventionalPlacement.placedSerialId);
      }
      conventionalPlacement.placedDevices.forEach(function (dev) {
        devs.push(dev);
      });
    });

    return { devs: devs, serialIds: serialIds };
  },

  convertCentersToDevs() {
    var fakeId = -1000;
    return this.flattenCenters(this.centerGroups)
    .filter(function (center) {
      return !center.noDraw;
    })
    .map(function (center) {
      var dev = {};
      dev.product_name_id = +center.devId;
      dev.x = +center.devPlacement[0];
      dev.y = +center.devPlacement[1];
      dev.roomId = +center.roomId;
      dev.angle = +center.devAngle;
      dev.deviceId = fakeId--;
      return dev;
    });
  },

  speakerPNIDs: [158, 159, 571],

  /**
   *
   * @param {Device[]} devices
   * @param {function} callback
   */
  groupDevices(devices, callback) {
    devices = devices.filter(device => device != null);
    var doneProm = $.Deferred();
    doneProm.done(function () {
      if (typeof callback == "function") {
        callback();
      }
    });

    if (devices.length < 2) {
      doneProm.resolve();
    }
    else {
      this.groupDevsRecursive(devices, 0, function () {
        doneProm.resolve();
      });
    }
  },

  /**
   *
   * @param {Device[]} devices
   * @param {number} idx
   * @param {function} callback
   */
  groupDevsRecursive(devices, idx, callback) {
    var thisVar = this;
    if (idx == devices.length) {
      if (typeof callback == "function") {
        callback();
      }
    }
    else if (idx == 0) {
      this.groupDevsRecursive(devices, 1, callback);
    }
    else {
      var src = devices[idx];
      var tar = devices[idx - 1];
      const next = () => {
        thisVar.groupDevsRecursive(devices, idx + 1, callback);
      };
      mouseupGroup(src.deviceId, tar.deviceId, next, next);
    }
  },

  sendGroupsRecursive(groups, idx, callback) {
    var thisVar = this;
    if (idx < groups.length) {
      this.groupDevices(groups[idx], function () {
        thisVar.sendGroupsRecursive(groups, idx + 1, callback);
      });
    }
    else {
      if (typeof callback == "function") {
        callback();
      } else {
        console.debug("no callback given for recursively sending groups! promise may not fulfill");
      }
    }
  },

  createGroups: function (callback, afterDevId) {
    var thisVar = this;

    // var speakerGroups = GROUP_BY(devices.filter(function (dev) {
    //     return thisVar.speakerPNIDs.indexOf(dev.product_name_id) != -1 && dev.deviceId > afterDevId;
    // }), "roomId");

    var convGroups = {};

    this.conventionalPlacements.forEach(function (placement) {
      if (Array.isArray(placement.groupIds)) {
        placement.groupIds.forEach(function (groupId, idx) {
          if (!(groupId in convGroups)) {
            convGroups[groupId] = [];
          }
          if (placement.placedDevices[idx]) {
            convGroups[groupId].push(placement.placedDevices[idx]);
          }
        });
      }
    });

    var convAppendGroups = GROUP_BY(thisVar.conventionalPlacements, "groupWithDevId");

    var groups = [];

    // for (var roomId in speakerGroups) {
    //     groups.push(speakerGroups[roomId]);
    // }
    for (var groupId in convGroups) {
      if (groupId !== "undefined") {
        groups.push(convGroups[groupId]);
      }
    }
    for (var devId in convAppendGroups) {
      if (devId !== "undefined") {
        var devs = convAppendGroups[devId].reduce(function (p, c) { return p.concat(c.placedDevices) }, []);
        var devToAppendTo = getDeviceById(devId);

        devs.unshift(devToAppendTo);
        groups.push(devs);
      }
    }

    this.sendGroupsRecursive(groups, 0, callback);
  },

  createSerialConnections: function () {
    const bothNewGrps = GROUP_BY(PLANNER_WIZARD.conventionalPlacements.filter(x => x.connId), 'connId');
    const bothNewGrpsArr = Object.values(bothNewGrps).filter(x => x.length === 2);

    const oneNewGrps = GROUP_BY(PLANNER_WIZARD.conventionalPlacements.filter(x => x.connToSerId), 'connToSerId');
    const oneNewGrpsArr = Object.values(oneNewGrps).filter(x => x.length === 1);

    return bothNewGrpsArr.reduce((prevProm, currElems) => {
      /* currElems.sort((a, b) => a.connUpper ? -1 : 0); */
      if (currElems[0].connUpper) {
        const temp = currElems[1];
        currElems[1] = currElems[0];
        currElems[0] = temp;
      }
      return prevProm.then(() => connectSerials(currElems[0].placedSerialId, currElems[1].placedSerialId));
    }, Promise.resolve())
    .then(() => oneNewGrpsArr.reduce((prevProm, currElems) => {
      return prevProm.then(() => connectSerials(currElems[0].placedSerialId, currElems[0].connToSerId));
    }, Promise.resolve()))
  },

  drawResults() {
    var thisVar = this;
    this.centerGroups.forEach(function (centerGroup) {
      centerGroup.centers.forEach(function (center) {
        PlannerGlobals.container.insert('svg:image')
          .attr('class', 'suggestionItem')
          .attr('width', PlannerGlobals.DEVICE_SIZE)
          .attr('height', PlannerGlobals.DEVICE_SIZE)
          .attr('x', center.devPlacement[0])
          .attr('y', center.devPlacement[1])
          .attr('transform', `rotate(${center.devAngle} ${center.devPlacement[0] + PlannerGlobals.DEVICE_SIZE / 2} ${center.devPlacement[1] + PlannerGlobals.DEVICE_SIZE / 2})`)
          .attr('xlink:href', calcImageURL(center.dev.image));
        if (PlannerGlobals.devices.length) {
          PlannerGlobals.container.insert('circle')
            .attr('class', 'suggestionItem')
            .attr('cx', center.devPlacement[0] + PlannerGlobals.DEVICE_SIZE / 5)
            .attr('cy', center.devPlacement[1] + PlannerGlobals.DEVICE_SIZE / 5)
            .attr('r', PlannerGlobals.DEVICE_SIZE / 5)
            .attr('fill', '#81e16d');
          PlannerGlobals.container.insert('svg:image')
            .attr('class', 'suggestionItem')
            .attr('xlink:href', calcImageURL("images/wand.svg"))
            .attr('width', PlannerGlobals.DEVICE_SIZE / 5 * 2 * 0.7)
            .attr('height', PlannerGlobals.DEVICE_SIZE / 5 * 2 * 0.7)
            .attr('x', center.devPlacement[0] + PlannerGlobals.DEVICE_SIZE / 5 * 0.3)
            .attr('y', center.devPlacement[1] + PlannerGlobals.DEVICE_SIZE / 5 * 0.3);
        }
      });
    });

    this.conventionalPlacements.forEach(function (placement) {
      var devs = uDevDOM.serialPNIDsToDevices(placement.pnids);
      var serCentDiff = getSerialCenterXY(placement.len);
      var center = {
        x: placement.point.x + serCentDiff.x,
        y: placement.point.y + serCentDiff.y
      }
      placement.devs = devs;
      if (placement.type == 'serial') {
        PlannerGlobals.container.insert('rect')
          .attr('class', 'suggestionItem')
          .attr('x', placement.point.x)
          .attr('y', placement.point.y)
          .attr('width', getFrameWidth(placement.len))
          .attr('height', getFrameHeight())
          .attr('transform', 'rotate(' + placement.rotation + ' ' + center.x + ' ' + center.y + ')')
          .attr('fill', 'rgba(255,255,255,0.3)')
          .attr('fill-opacity', 0.2)
          .attr('stroke', 'black')
          .attr('stroke-width', GET_SER_BORDER_WIDTH())
          .attr('rx', 2 * PlannerGlobals.DEVICE_SIZE / 20)
          .attr('ry', 2 * PlannerGlobals.DEVICE_SIZE / 20);
      }
      if (PlannerGlobals.devices.length) {
        PlannerGlobals.container.append('circle')
          .attr('class', 'suggestionItem suggCirc')
          .attr('cx', placement.point.x + PlannerGlobals.DEVICE_SIZE / 5)
          .attr('cy', placement.point.y + PlannerGlobals.DEVICE_SIZE / 5)
          .attr('r', PlannerGlobals.DEVICE_SIZE / 5)
          .attr('fill', '#81e16d')
          .attr('transform', 'rotate(' + placement.rotation + ' ' + center.x + ' ' + center.y + ')');
        PlannerGlobals.container.append('svg:image')
          .attr('class', 'suggestionItem')
          .attr('xlink:href', calcImageURL("images/wand.svg"))
          .attr('width', PlannerGlobals.DEVICE_SIZE / 5 * 2 * 0.7)
          .attr('height', PlannerGlobals.DEVICE_SIZE / 5 * 2 * 0.7)
          .attr('x', placement.point.x + PlannerGlobals.DEVICE_SIZE / 5 * 0.3)
          .attr('y', placement.point.y + PlannerGlobals.DEVICE_SIZE / 5 * 0.3)
          .attr('transform', 'rotate(' + placement.rotation + ' ' + center.x + ' ' + center.y + ')');
      }
      devs.forEach(function (dev, idx) {
        var dist = GET_SER_MARG() + idx * (PlannerGlobals.DEVICE_SIZE + SERIAL_SPACING);
        var origidevpos = { x: placement.point.x + dist + PlannerGlobals.DEVICE_SIZE / 2, y: placement.point.y + GET_SER_MARG() + PlannerGlobals.DEVICE_SIZE / 2 };
        var rotatedpos = rotatePointAroundAnotherXY(origidevpos, center, placement.rotation);
        rotatedpos.x -= PlannerGlobals.DEVICE_SIZE / 2;
        rotatedpos.y -= PlannerGlobals.DEVICE_SIZE / 2;

        PlannerGlobals.container.insert('svg:image', '.suggCirc')
          .attr('x', rotatedpos.x)
          .attr('y', rotatedpos.y)
          .attr('xlink:href', calcImageURL(dev.icon))
          .attr('width', PlannerGlobals.DEVICE_SIZE)
          .attr('height', PlannerGlobals.DEVICE_SIZE)
          .attr('class', "suggestionItem")
          .attr('transform', 'rotate(' + placement.rotation + ' ' + (rotatedpos.x + PlannerGlobals.DEVICE_SIZE / 2) + ' ' + (rotatedpos.y + PlannerGlobals.DEVICE_SIZE / 2) + ')');

        if (dev.qty > 1) {
          var devCenter = { x: rotatedpos.x + PlannerGlobals.DEVICE_SIZE / 2, y: rotatedpos.y + PlannerGlobals.DEVICE_SIZE / 2 };
          /* var devTopRight = { x: rotatedpos.x + DEVICE_SIZE * 0.95, y: rotatedpos.y + DEVICE_SIZE * 0.1 }; */
          var devBottomCenter = { x: rotatedpos.x + PlannerGlobals.DEVICE_SIZE * 0.5, y: rotatedpos.y + PlannerGlobals.DEVICE_SIZE };
          var rotatedQtyPos = rotatePointAroundAnotherXY(devBottomCenter, devCenter, placement.rotation);
          var fontSize = PlannerGlobals.DEVICE_SIZE / 3 * 0.9;
          var badgeId = +new Date();


          var textElem = PlannerGlobals.container.append('text')
          .attr('id', 'qty_badge_' + badgeId)
          .attr('class', 'quote-number suggestionItem')
          .attr('x', rotatedQtyPos.x)
          .attr('y', rotatedQtyPos.y + fontSize / 2)
          .attr('font-size', fontSize)
          .attr('font-weight', '600')
          .attr('fill', 'black')
          .attr('text-anchor', 'middle')
          .text(dev.qty);

          var bbox = textElem.node().getBBox();
          /* var width = Math.max(bbox.width, bbox.height); */
          PlannerGlobals.container.insert('rect', '#qty_badge_' + badgeId)
          .attr('class', 'quote-number suggestionItem')
          .attr('x', bbox.x - (bbox.height - bbox.width) / 2)
          .attr('y', bbox.y)
          .attr('height', bbox.height)
          .attr('width', bbox.height)
          .attr('rx', PlannerGlobals.DEVICE_SIZE / 5)
          .attr('ry', PlannerGlobals.DEVICE_SIZE / 5)
          .attr('fill', '#fafa00');
          /* .attr('fill-opacity', 0.8); */
        }
      });
    });
  },

  shuffle(array) {
    var currentIndex = array.length, temporaryValue, randomIndex;

    // While there remain elements to shuffle...
    while (0 !== currentIndex) {

      // Pick a remaining element...
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex -= 1;

      // And swap it with the current element.
      temporaryValue = array[currentIndex];
      array[currentIndex] = array[randomIndex];
      array[randomIndex] = temporaryValue;
    }

    return array;
  },

  /**
   *
   * @param {ConventionalPlacement[]} placements
   * @param {number} idx
   * @param {function} callback
   */
  putConvPlacementsNew(placements, idx = 0, callback) {
    if (idx >= placements.length) {
      if (typeof callback === "function") {
        callback();
      }
    }
    else {
      var thisVar = this;
      placements[idx].placedDevices = [];
      this.putPlacementNew(placements[idx], function () {
        PLANNER_WIZARD.incrementPlaceds();
        thisVar.putConvPlacementsNew(placements, idx + 1, callback);
      });
    }
  },

  /**
   *
   * @param {ConventionalPlacement} placement
   * @param {*} callback
   */
  putPlacementNew(placement, callback) {
    var pnidDevs = placement.pnids.map(getProductById);
    var pos = placement.point;
    var deg = placement.rotation;
    var roomId = placement.room.id;
    var firstSerialTarget = placement.targetSerialId ? getSerialById(placement.targetSerialId) : null;

    if (pnidDevs.length === 0) {
      if (typeof callback === "function") {
        callback();
      }
      return;
    }

    // place first
    placeDevice(pos.x, pos.y, roomId, pnidDevs[0], function (dev, resp, seri) {
      if (dev) {
        placement.placedDevices[0] = dev;
        PLANNER_WIZARD.placedDevIds.push(dev.deviceId);
        if (seri && placement.type === "serial") {
          placement.placedSerialId = seri.id;
        }

        var tarser = getSerialOfDeviceId(dev.deviceId);
        var promises = [];

        // place others
        for (let i = 1; i < pnidDevs.length; i++) {
          let prom = $.Deferred();
          promises.push(prom);
          placeDevice(pos.x, pos.y, roomId, pnidDevs[i], function (dev) { placement.placedDevices[i] = dev; prom.resolve(); },
              !tarser, tarser, deg, true);
        }

        whenAll(promises).done(function () { if (typeof callback === "function") { callback(); } });
      }
      else {
        callback(false);
      }
    }, true, firstSerialTarget, deg, true);
  },

  putConvPlacements(placements, idx = 0, callback, errorCallback) {
    var thisVar = this;
    if (idx < placements.length) {
      PLANNER_WIZARD.incrementPlaceds();
      placements[idx].placedDevices = [];
      this.putPlacement(placements[idx], 0, function () { thisVar.putConvPlacements(placements, idx + 1, callback, errorCallback) }, null, errorCallback);
    }
    else {
      if (callback) {
        callback();
      }
    }
  },

  putPlacement(placement, idx = 0, callback, targetSerial = null, errorCallback, currCallback) {
    var thisVar = this;
    if (idx < placement.pnids.length) {
      var pnidDevs = placement.pnids.map(getProductById);
      var pos = placement.point;
      var deg = placement.rotation;
      var roomId = placement.room.id;
      var serialNeedAdjust = false;
      if (placement.targetSerialId) {
        targetSerial = getSerialById(placement.targetSerialId);
        serialNeedAdjust = true;
      }

      placeDevice(pos.x, pos.y, roomId, pnidDevs[idx], function (dev, resp, seri) {
        if (dev) {
          placement.placedDevices[idx] = dev;
          PLANNER_WIZARD.placedDevIds.push(dev.deviceId);
          if (seri && placement.type === "serial") {
            placement.placedSerialId = seri.id;
          }
          if (idx == 0) {
            var tarser = getSerialOfDeviceId(dev.deviceId);
            var promises = [];
            for (var i = 1; i <= pnidDevs.length; i++) {
              let prom = $.Deferred();
              if (i != pnidDevs.length) {
                promises.push(prom);
              }
              thisVar.putPlacement(placement, i, callback, tarser ? tarser : null, errorCallback, function () { prom.resolve(); });
            }
            $.when.apply($, promises).always(function () {
              if (!$('.suggestionItem').length) {
                redrawDevices();
              }
            });
          }
        }

        if (!dev && callback) {
          callback();
        }

        else if (dev && currCallback) {
          currCallback();
        }

      }, !targetSerial, targetSerial, deg, !serialNeedAdjust);
    }
    else {
      if (callback) {
        callback();
      }
    }
  },

  getBiggestDevId() {
    if (PlannerGlobals.devices.length > 0) {
      return Math.max.apply(this, PlannerGlobals.devices.map(function (dev) { return dev.deviceId; }));
    }
    else {
      return -1;
    }
  },

  incrementPlaceds() {
    var percent = Math.round(++PLANNER_WIZARD.PLACED_ELEMS / PLANNER_WIZARD.ALL_ELEMS_TO_PLACE * 100);
    setLoadingProgress(percent);
  },

  ALL_ELEMS_TO_PLACE: 0,
  PLACED_ELEMS: 0,

  IS_LOADING: false,

  /**
   * @type {number[]}
   */
  placedDevIds: [],

  /**
   *
   * @returns {Device[]}
   */
  getDevsToRemove() {
    const delDevIds = {};

    this.deleteRequests
    .reduce(function (p, c) {
      return p.concat(c.deleteDeviceIds);
    }, [])
    .forEach(devId => {
      if (delDevIds[devId]) {
        console.debug(devId, 'has beed requested to delete multiple times!');
      }
      delDevIds[devId] = true;
    });

    return Object.keys(delDevIds)
    .map(function (devId) {
      return getDeviceById(devId);
    })
    .filter(function (dev) {
      return !!dev;
    });
  },
  lastDelMultDevAction: null,
  acceptChanges() {
    if (PLANNER_WIZARD.IS_LOADING) {
      return;
    }
    var thisVar = this;

    thisVar.lastDelMultDevAction = null;

    $('#confirm-modify-btn, #undo-modify-btn').addClass('hidden');
    PLANNER_WIZARD.IS_LOADING = true;
    showLoadingOverlay('progress');
    var maxDevId = this.getBiggestDevId();
    toastRemoveAll();

    $('#wizard-btn-' + PLANNER_WIZARD.lastStartedMode).find('.rotate-cog').removeClass('hidden');
    /* $('.rooms polygon').addClass('roomInProgress'); */
    $('#svgAndChat').addClass('pulsing');

    PLANNER_WIZARD.placedDevIds = [];
    var wasThereProblem = false;
    var problemMsg;
    var centers = [];
    var promises = [];
    this.centerGroups.forEach(function (centerGroup) {
      centerGroup.centers.forEach(function (center) {
        var promise = $.Deferred();
        promises.push(promise);
        centers.push({ center, promise });
      });
    });


    var removeDevPromise = $.Deferred();
    var devsToRemove = this.getDevsToRemove();
    if (!devsToRemove.length) {
      removeDevPromise.resolve();
    }
    else {
      /* toastInfoSingle(txt); */
      removeTheseDevs(devsToRemove, function (deletedDevs, groups, measures, serConns) {
        thisVar.lastDelMultDevAction = new DeleteMultipleDevicesAction(deletedDevs, groups, measures, serConns);
        removeDevPromise.resolve();
      });
      var txt = (ts('p_wiz_deleting', "Deleting devices...")) + " (1/2)"
      setLoadingText(txt);
    }

    var convProm = $.Deferred();
    promises.push(convProm);

    PLANNER_WIZARD.ALL_ELEMS_TO_PLACE = centers.length + thisVar.conventionalPlacements.length;
    PLANNER_WIZARD.PLACED_ELEMS = 0;

    removeDevPromise.always(function () {
      var txt = (ts('p_wiz_placing', "Placing devices..."));
      if (thisVar.lastDelMultDevAction) {
        txt += " (2/2)";
      }
      /* toastInfoSingle(txt); */
      setLoadingText(txt);
      for (var i = 0; i < centers.length; i++) {
        let centerObj = centers[i];
        placeDevice(centerObj.center.devPlacement[0],
            centerObj.center.devPlacement[1],
            centerObj.center.roomId,
            centerObj.center.dev,
            function (placedDevice, errorMessage) {
              try {
                PLANNER_WIZARD.incrementPlaceds();
                if (!placedDevice) { wasThereProblem = true; problemMsg = errorMessage; }
                else {
                  centerObj.center.placedDeviceId = placedDevice.deviceId;
                  PLANNER_WIZARD.placedDevIds.push(placedDevice.deviceId);
                }
              } finally {
                centerObj.promise.resolve();
              }
            },
            !centerObj.center.serializable,
            null,
            centerObj.center.devAngle,
            true);
      }

      thisVar.putConvPlacements(thisVar.conventionalPlacements, 0, function () {
        console.log('conventional done');
        convProm.resolve();
      }, function (msg) {
        wasThereProblem = true;
      });
    });

    var groupingPromise = $.Deferred();
    var serialConnectionPromise = $.Deferred();

    $.when.apply($, promises).done(function () {
      console.log('proms done, creating groups, serialconnections');

      thisVar.createGroups(function () {
        groupingPromise.resolve();
        console.log('creating groups done');
      }, maxDevId);

      thisVar.createSerialConnections()
      .then(() => {
        serialConnectionPromise.resolve();
        console.log('creating serialconnections done');
      })
      .catch(() => {
        serialConnectionPromise.reject();
      });
    });

    try{


      // $.when.apply($, promises.concat([serialConnectionPromise]))
      $.when.apply($, promises.concat([groupingPromise, serialConnectionPromise]))
      .always(function (msg) {
        console.log('finishing wizard placing');
        $('#svgAndChat').removeClass('pulsing');
        d3.selectAll('.suggestionItem').remove();
        setMode.basic();
        $('#wizard-btn-' + PLANNER_WIZARD.lastStartedMode).find('.rotate-cog').addClass('hidden');
        PLANNER_WIZARD.IS_LOADING = false;
        hideLoadingOverlay();
        try {
          checkTooBigDevices(true, null, true);
          redrawDevices();
          refreshFloorView();

          if (Array.isArray(PLANNER_WIZARD.placedDevIds) && PLANNER_WIZARD.placedDevIds.length) {
            if (!PLANNER_WIZARD.autoAccept) {
              snackSuccess(ts('p_wiz_placed', "Devices placed!"));
            }
            var wizAction = new WizardPlaceAction(PLANNER_WIZARD.placedDevIds, PLANNER_WIZARD.centerGroups, PLANNER_WIZARD.conventionalPlacements);
            if (thisVar.lastDelMultDevAction) {
              var actions = [thisVar.lastDelMultDevAction, wizAction];
              PlannerGlobals.plannerHistoryManager.addHistoryEntry(new MultiPlannerAction(actions));
            }
            else {
              PlannerGlobals.plannerHistoryManager.addHistoryEntry(wizAction);
            }
          }

          if (wasThereProblem) {
            snackError(problemMsg || msg || ts('p_wiz_noplacedperm', "Only those items got placed that you can manage in this project."));
          }
        }
        catch (error) {
          console.error('wizard finishing failed', error);
        }

        document.dispatchEvent(new Event(WIZARD_PLACED_EVENT));
      });
    }
    catch(error){
      console.log( 'csokika', error )
    }
  },

  declineChanges() {
    redrawDevices();
    if (!$('#svgAndChat').hasClass('pulsing')) {
      d3.selectAll('.suggestionItem').remove();
      setMode.basic();
    }
  },

  splitUp(arr, n) {
    var rest = arr.length % n, // how much to divide
        restUsed = rest, // to keep track of the division over the elements
        partLength = Math.floor(arr.length / n),
        result = [];

    for (var i = 0; i < arr.length; i += partLength) {
      var end = partLength + i,
          add = false;

      if (rest !== 0 && restUsed) { // should add one element for the division
        end++;
        restUsed--; // we've used one division element now
        add = true;
      }

      result.push(arr.slice(i, end)); // part of the array

      if (add) {
        i++; // also increment i in the case we added an extra element for division
      }
    }
    return result;
  },

  /**
   *
   * @param {"smarthome" | "leaf" | "conventional" | "it" | "aio"} bundleType
   */
  start(bundleType = "smarthome", config = false) {
    if (['smarthome', 'leaf', 'conventional', 'it', 'aio', 'aio2nd'].indexOf(bundleType) == -1) {
      return false;
    }

    var busyReason = isPlannerBusy();
    if (busyReason) {
      snackInfo(busyReason);
      return false;
    }

    var thisVar = this;
    this.lastStartedMode = bundleType;
    if (!window.Worker) {
      toastRemoveAll();
      snackInfo("This browser doesn't support this feature. To use it, please upgrade to a newer one.");
      return false;
    }
    if (PlannerGlobals.mode == 'wizard') return false;
    if (!PlannerGlobals.LENGTHOF1PX) {
      toastRemoveAll();
      snackInfo(ts('p_wiz_warnprop', "To run the uPlan Wizard, you have to set the room's proportions. <b>(Hotkey: 2)</b>"));
      return false;
    }
    if (PlannerGlobals.rooms.length == 0) {
      toastRemoveAll();
      snackInfo(ts('p_wiz_warnrooms', "To run the uPlan Wizard, you have to create rooms first. <b>(Hotkey: 1)</b>"));
      return false;
    }
    setMode.wizard();
    PLANNER_WIZARD.startLoading();

    thisVar.incompleteRooms = [];
    thisVar.conventionalPlacements = [];
    thisVar.deleteRequests = [];
    thisVar.centerGroups = [];
    thisVar.workers = [];
    thisVar.workerPromises = [];
    thisVar.workerPromises2ndRound = [];
    var workerN = navigator.hardwareConcurrency || 1;
    var remainingRooms = Object.assign([], PlannerGlobals.rooms);
    var wifiCalcNeeded = bundleType == "it" /* || bundleType == "aio" */;
    var remainingInnerWifiRooms = getInnerRooms(PlannerGlobals.rooms, PlannerGlobals.outerBorder);/* .filter(function (room) {
            var roomIsWet = room.room_type_id == 7 || room.room_type_id == 8;
            return !roomIsWet;
        }); */
    var remainingOuterWifiRooms = getOuterRooms(PlannerGlobals.rooms, PlannerGlobals.outerBorder).filter(function (room) {
      return room.room_type_id == ROOM_TYPES.TerraceOrBalcony;
    });
    var stillNeedRound2 = bundleType == "aio";
    for (var i = 0; i < workerN && i < remainingRooms.length; i++) {
      let workerPromise = $.Deferred();
      let workerPromise2ndRound = $.Deferred();
      thisVar.workerPromises.push(workerPromise);
      thisVar.workerPromises2ndRound.push(workerPromise2ndRound);
      let worker = new Worker(new URL('./wizard-worker.js', import.meta.url));
      thisVar.workers.push(worker);
      worker.onmessage = function (e) {
        if ('currentRoom' in e.data) {
          $('.rooms [data-roomId="' + e.data.currentRoom + '"]').addClass('roomInProgress');
        }
        else if ('doneRoom' in e.data) {
          $('.rooms [data-roomId="' + e.data.doneRoom + '"]').addClass('roomDone').removeClass('roomInProgress');
        }
        else if ('result' in e.data) {
          if (PlannerGlobals.mode == "wizard") {
            // store results
            if (e.data.bundleType == "smarthome" || e.data.bundleType == "leaf" || e.data.bundleType == "it" || e.data.bundleType == "aio") {
              thisVar.deleteRequests = thisVar.deleteRequests.concat(e.data.deleteRequests);
              thisVar.centerGroups = thisVar.centerGroups.concat(e.data.result);
            }

            else if (e.data.bundleType == "conventional" || e.data.bundleType == "aio2nd") {
              thisVar.conventionalPlacements = thisVar.conventionalPlacements.concat(e.data.result);
              thisVar.deleteRequests = thisVar.deleteRequests.concat(e.data.deleteRequests);
              thisVar.incompleteRooms = thisVar.incompleteRooms.concat(e.data.incompleteRooms);
            }

            // is there more work to do?
            if (remainingRooms.length > 0) {
              var room = remainingRooms.pop();
              // console.debug('reusing worker for room', room)
              worker.postMessage({
                type: 'roomcalc',
                rooms: [room],
                bundleType,
              });
            }
            else if (wifiCalcNeeded && remainingInnerWifiRooms.length && !remainingInnerWifiRooms.calculating) {
              remainingInnerWifiRooms.calculating = true;
              worker.postMessage({
                type: 'floorcalc',
                rooms: PlannerGlobals.rooms,
                searchRooms: remainingInnerWifiRooms,
                whichRooms: 'inner',
                wifi_band: WIFI_BAND,
                wifi_product_name_id: WizardGlobals.WIFI_PRODUCT_ID,
                materials: PlannerGlobals.CURRENT_MATERIALS
              });

            }
            else if (WIFI_BAND == WIFI_BANDS._5 && wifiCalcNeeded && remainingOuterWifiRooms.length && !remainingOuterWifiRooms.calculating) {
              remainingOuterWifiRooms.calculating = true;
              worker.postMessage({
                type: 'floorcalc',
                rooms: PlannerGlobals.rooms,
                searchRooms: remainingOuterWifiRooms,
                whichRooms: 'outer',
                wifi_band: WIFI_BAND,
                wifi_product_name_id: WizardGlobals.WIFI_PRODUCT_ID,
                materials: PlannerGlobals.CURRENT_MATERIALS
              });
            }
            else {
              workerPromise.resolve();
              if (e.data.bundleType == "aio2nd") {
                workerPromise2ndRound.resolve();
              }
            }
          }
        }
        else if ('msg' in e.data) {
          console.debug(e.data.msg);
        }
      }
      worker.onerror = function (e) {
        console.error('wizard worker error:', e.message, (e.filename || '') + ':' + e.lineno, e);
        workerPromise.resolve();
      }
    }

    performance.clearMarks();
    performance.clearMeasures();
    performance.mark('calcStart');
    
    var deviceCategoryLookup = deviceProvider.getDeviceCategoryLookup();

    const wallsForWifiCalc = PlannerGlobals.wallSegmentation.getWallSegmentsWithMaterials();
    const ceilingsForSpeakerCalc = PlannerGlobals.wallSegmentation.getCeilingTypes();
    thisVar.workers.forEach(function (worker) {
      var room = remainingRooms.pop();
      // console.debug('starting NEW worker for room', room)
      worker.postMessage({
        type: 'roomcalc',
        rooms: [room],
        allRooms: uDev.roomsExtended,
        comfortLevel: PlannerGlobals.comfortLevel,
        lengthof1px: PlannerGlobals.LENGTHOF1PX,
        device_size: PlannerGlobals.DEVICE_SIZE,
        serial_spacing: SERIAL_SPACING,
        devices: PlannerGlobals.devices,
        serials: PlannerGlobals.serials,
        serialConnections: PlannerGlobals.serialConnections,
        groups: PlannerGlobals.groups,
        wallMods: PlannerGlobals.wallModConnections,
        items: PlannerGlobals.wizard_items,
        outerWallIds: PlannerGlobals.outerWallIds,
        outerBorder: PlannerGlobals.outerBorder,
        bundleType,
        config,
        outdoorsRoomId: uDev.OUTDOORS_ROOM_ID,
        deviceCategoryLookup,
        wallsForWifiCalc,
        ceilingsForSpeakerCalc,
        isPro: true /* IS_PRO */
      });
    });

    $.when.apply($, thisVar.workerPromises).done(function () {
      /* console.log(bundleType, stillNeedRound2); */
      if (bundleType == "aio" && stillNeedRound2) {
        stillNeedRound2 = false;
        bundleType = "aio2nd";
        remainingRooms = Object.assign([], PlannerGlobals.rooms);
        thisVar.postProcessResults();
        var round1Placed = thisVar.convertCentersToDevs();
        var allPlaced = PlannerGlobals.devices.concat(round1Placed);
        thisVar.workers.forEach(function (worker) {
          worker.postMessage({ type: 'clear' });
          var room = remainingRooms.pop();
          worker.postMessage({
            type: 'roomcalc',
            rooms: [room],
            bundleType,
            devices: allPlaced,
            wallMods: PlannerGlobals.wallModConnections
          });
        });
      }
      else {
        /* console.log('wizard fully done'); */
        thisVar.resetWorkers();
        PLANNER_WIZARD.postProcessResults();
        PLANNER_WIZARD.drawResults();
        PLANNER_WIZARD.stopLoading();
        performance.mark('calcEnd');
        performance.measure('calc', 'calcStart', 'calcEnd');
        printTimeTaken('calc');
      }
      /*  console.log('calculated in ' + Math.round(performance.getEntriesByName('calc')[0].duration) + 'ms'); */
      // console.log(thisVar.conventionalPlacements);
    });

    if (bundleType == "aio") {
      $.when.apply($, thisVar.workerPromises2ndRound).done(function () {
        console.log('wizard fully done');
        thisVar.resetWorkers();
        PLANNER_WIZARD.postProcessResults();
        PLANNER_WIZARD.drawResults();
        PLANNER_WIZARD.stopLoading();
        performance.mark('calcEnd');
        performance.measure('calc', 'calcStart', 'calcEnd');
        printTimeTaken('calc');
      });
    }
    return true;
  },

  resetWorkers() {
    this.workers.forEach(function (worker) {
      worker.terminate();
    });
    this.workers = [];
    this.workerPromises = [];
    $('.roomInProgress, .roomDone').removeClass('roomInProgress').removeClass('roomDone');
  },

  DEBUG_clearDevs() {
    removeDevices(PlannerGlobals.devices).always(redrawDevices);
  },

  DEBUG_clearWallMods() {
    PlannerGlobals.wallModConnections.forEach(wallMod => {
      wallModHelperDOM.removeWallModConn(wallMod.id);
    });
  },

  DEBUG_clearFloor() {
    this.DEBUG_clearDevs();
    this.DEBUG_clearWallMods();
  }
}

export function startAutoPlanWizard(bundle, onPlaced, onFailed) {
  let finished = false;
  const finish = (ok) => {
    if (finished) return;
    finished = true;
    document.removeEventListener(WIZARD_PLACED_EVENT, handlePlaced);
    PLANNER_WIZARD.autoAccept = false;
    const callback = ok ? onPlaced : onFailed;
    if (typeof callback === 'function') {
      callback();
    }
  };
  const handlePlaced = () => finish(true);
  document.addEventListener(WIZARD_PLACED_EVENT, handlePlaced);

  PLANNER_WIZARD.autoAccept = true;

  instantCalcOuter(function () {
    if (PLANNER_WIZARD.start(bundle) !== true) {
      finish(false);
    }
  }, function () {
    finish(false);
  });
}
